<template>
	<view>
		<amap v-if="mapType === 'amap'" :disable="disable" :longitude="longitude" :latitude="latitude" :mapKey="mapKey"
			:marker="marker" @confirm="confirm" @changeMarker="changeMarker" :polygons="polygons"
			:isPolygons="isPolygons" :isCustomBar="isCustomBar" :top='top'>
		</amap>
	</view>
</template>

<script>
	import amap from '../amap/amap.vue';

	export default {
		name: 'atl-map',
		props: {
			longitude: {
				type: String,
				default: ''
			},
			latitude: {
				type: String,
				default: ''
			},
			mapKey: {
				require: true,
				type: String,
				default: ''
			},
			marker: {
				type: Object,
				default: () => {}
			},
			mapType: {
				type: String,
				default: 'tmap'
			},
			disable: {
				type: Boolean,
				default: false
			},
			isPolygons: {
				type: Boolean,
				default: false
			},
			polygons: {
				type: Array,
				default: () => []
			},
			top: {
				type: [String, Number],
				default: 30
			},
			isCustomBar: {
				type: Boolean,
				default: false
			}
		},
		components: {
			amap
		},
		data() {
			return {};
		},
		created() {
			// console.log(11, this.$props);
		},
		methods: {
			confirm(e) {
				this.$emit('confirm', e);
			},
			changeMarker(e) {
				this.$emit('changeMarker', e);
			}
		}
	};
</script>

<style lang="scss" scoped></style>